import React, { useCallback, useEffect, useState } from "react";
import styles from "./categories.module.css";
import left from "../../images/catalogues/chevron-left.svg";
import right from "../../images/catalogues/chevron-right.svg";
import chevronDown from "../../images/chevron-down.svg";
import Spinner from "../Spinner/Spinner";
import BackdropD from "../Backdrop_Dropdown/Backdrop";

function Categories({
  onCategoryClick,
  categories: categoriesProp,
  currentCategory,
}) {
  const [currentCategoryIndex, setCurrentCategoryIndex] = useState(0);
  const [categories, setCategories] = useState(categoriesProp);
  const [spin, setSpin] = useState(true);
  const [drop, setDrop] = useState(false);
  const [value, setValue] = useState(currentCategory || 0);
  const scrollTo = useScrollToId();
  const [openDropdownId, setOpenDropdownId] = useState(new Set());
  const getSubcategoriesForCategory = (category) => {
    if (!category || !Array.isArray(category.subCategories)) return [];
    return [...category.subCategories]
      .filter((s) => s.isActive !== false)
      .sort((a, b) => {
        const sa = typeof a.sortId === "number" ? a.sortId : 0;
        const sb = typeof b.sortId === "number" ? b.sortId : 0;
        return sa - sb;
      });
  };

  const handleCategoryClick = (categoryName, index, event) => {
    if (event && event.target.closest(".subcategoryDropdown")) {
      return;
    }

    if (onCategoryClick) {
      setDrop(false);
      onCategoryClick(categoryName);
    } else {
      setValue(categoryName);
      setCurrentCategoryIndex(index);
      setDrop(false);
      // Fallback to old scroll behavior
      scrollTo(categoryName);
    }
  };

  const toggleSubcategoryDropdown = (categoryId, event) => {
    event.stopPropagation();
    setOpenDropdownId((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(categoryId)) {
        newSet.delete(categoryId);
      } else {
        newSet.add(categoryId);
      }
      return newSet;
    });
  };


  let update = (i) => {
    if (onCategoryClick) {
      onCategoryClick(i);
    } else {
      setValue(i);
      scrollTo(i);
    }
  };

  const onPrevCategoryButtonClick = () => {
    if (onCategoryClick) {
      setDrop(false);
      onCategoryClick(categories[currentCategoryIndex - 1].name);
    } else {
      setValue(categories[currentCategoryIndex - 1].name);
      setCurrentCategoryIndex(currentCategoryIndex - 1);
      setDrop(false);
      scrollTo(categories[currentCategoryIndex - 1].name);
    }
  };

  const onNextCategoryButtonClick = () => {
    if (onCategoryClick) {
      setDrop(false);
      onCategoryClick(categories[currentCategoryIndex + 1].name);
    } else {
      setValue(categories[currentCategoryIndex + 1].name);
      setCurrentCategoryIndex(currentCategoryIndex + 1);
      setDrop(false);
      scrollTo(categories[currentCategoryIndex + 1].name);
    }
  };

  const change = () => {
    setDrop(false);
  };

  useEffect(() => {
    if (categoriesProp && categoriesProp.length > 0) {
      setSpin(false);
      setCategories(categoriesProp);
    }
  }, [categoriesProp]);

  useEffect(() => {
    if (!categoriesProp || !categoriesProp.length || !currentCategory) return;

    setValue(currentCategory);
    const index = categoriesProp.findIndex((c) => c.name === currentCategory);
    if (index >= 0) {
      setCurrentCategoryIndex(index);
    }
  }, [currentCategory, categoriesProp]);

  return (
    <>
      {drop ? <BackdropD show={true} switch={change} /> : null}
      {spin ? (
        <Spinner />
      ) : (
        <>
          <div className={styles.categorymobile}>
            <div className={styles.categorymobilecontainer}>
              <div className={styles.categorymobile_heading}>
                <h3>Categories</h3>
              </div>
              <hr />
              <div className={styles.categorymobile_options}>
                <div
                  onClick={onPrevCategoryButtonClick}
                  style={{ cursor: "pointer" }}
                >
                  <div>
                    <img src={left} alt="Prev Arrow" />
                  </div>
                </div>
                <div
                  className={styles.categorymobile_options_active}
                  onClick={() => setDrop(!drop)}
                >
                  <img
                    src={categories[currentCategoryIndex].images[1]}
                    alt=""
                  />
                  <h3>{value == "" ? categories[0].name : value}</h3>
                </div>
                <div
                  onClick={onNextCategoryButtonClick}
                  style={{ cursor: "pointer" }}
                >
                  <div>
                    <img src={right} alt="Next Arrow" />
                  </div>
                </div>
              </div>
            </div>
            {drop ? (
              <div className={styles.categorymobile_dropdown}>
                <div className={styles.categorymobile_dropdown_names}>
                  <ul>
                    {categories.map((i, index) => {
                      return (
                        <li
                          key={i._id}
                          className={`${styles.categoryItem} ${
                            value === i.name ? styles.categoryItemActive : ""
                          }`}
                          onClick={() => {
                            if (onCategoryClick) {
                              setDrop(false);
                              onCategoryClick(i.name);
                            } else {
                              update(i.name);
                              setCurrentCategoryIndex(index);
                              setDrop(false);
                            }
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <div className={styles.a1}>
                            {value === i.name ? (
                              <img src={i.images[1]} alt="" />
                            ) : (
                              <img
                                src={i.images[0]}
                                alt=""
                                style={{
                                  border: "1px solid rgba(52, 52, 52, 0.64)",
                                  borderRadius: "50%",
                                }}
                              />
                            )}
                            <div className={styles.name}>{i.name}</div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            ) : null}
          </div>
          <div className={styles.cgrs}>
            <div className={styles.topic}>
              <p>Categories</p>
            </div>
            <hr />
            <div className={styles.lis}>
              <ul>
                {categories.map((i, index) => {
                  const subcategories = getSubcategoriesForCategory(i);
                  const hasSubcategories = subcategories.length > 0;
                  const isDropdownOpen = openDropdownId.has(i._id);

                  return (
                    <li
                      key={i._id}
                      className={`${styles.categoryContainer} ${
                        value === i.name ? styles.categoryContainerActive : ""
                      } ${
                        isDropdownOpen ? styles.categoryContainerExpanded : ""
                      }`}
                    >
                      <div
                        className={styles.categoryItem}
                        onClick={(e) => handleCategoryClick(i.name, index, e)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className={styles.a1}>
                          {value === i.name ? (
                            <img src={i.images[1]} alt="" />
                          ) : (
                            <img
                              src={i.images[0]}
                              alt=""
                              style={{
                                border: "1px solid rgba(52, 52, 52, 0.64)",
                                borderRadius: "50%",
                              }}
                            />
                          )}
                          <div className={styles.name}>{i.name}</div>
                          {hasSubcategories && (
                            <div
                              className={styles.subcategoryDropdown}
                              onClick={(e) =>
                                toggleSubcategoryDropdown(i._id, e)
                              }
                            >
                              <img
                                src={chevronDown}
                                alt=""
                                className={`${styles.chevronIcon} ${
                                  isDropdownOpen ? styles.chevronIconOpen : ""
                                }`}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      {hasSubcategories && isDropdownOpen && (
                        <div className={styles.subcategoryListContainer}>
                          <ul className={styles.subcategoryList}>
                            {subcategories.map((sub) => (
                              <li
                                key={sub._id}
                                className={styles.subcategoryItem}
                                onClick={(e) => handleCategoryClick(i.name, index, e)}

                              >
                                <div className={styles.subcategoryName}>
                                  {sub.name}
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </>
      )}
    </>
  );
}

function useScrollToId() {
  const scrollTo = useCallback((id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);

  return scrollTo;
}

export default Categories;
